import { render } from "./TextbookPageNav.vue?vue&type=template&id=186993e5&scoped=true"
import script from "./TextbookPageNav.vue?vue&type=script&lang=js"
export * from "./TextbookPageNav.vue?vue&type=script&lang=js"

import "./TextbookPageNav.vue?vue&type=style&index=0&id=186993e5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186993e5"]])

export default __exports__